<template>
    <div class="traffic-chart">
        <div v-if="is_daily && !isGuest" class="edit-annotations" :class="{'editing':editAnnotations}" @click="editAnnotationsData">
            <span class="edit-annotations">
            <simple-svg :filepath="$store.state.app_url+'/images/icons/annotate.svg/'"  />
            </span>
        </div>
        <div v-if="editAnnotations && is_daily && !isGuest" class="row justify-content-center mt-5 mb-2">
            <transition name="fade-edit">
                <div v-show="showAnnotations" class="col">
                    <div class="row mb-5">
                        <div class="col highlights-wrap" data-highlight="high1">
                            <div class="d-flex">
                                <label class="font-weight-bold mt-1 mr-1">Date:</label>
                                <v-select class="ml-1 mr-5" v-model="current_date_point" label="date_point" :options="date_points"></v-select>
                                <label class="font-weight-bold mt-1 mr-1 ml-5">Category:</label>
                                <v-select class="ml-1" v-model="current_category" label="category" :options="categories"></v-select>
                            </div>
                            <h6 class="font-weight-bold mt-4 mb-2">Annotation: </h6>
                            <textarea class="froala-annotations highlight_1">{{raw_annotation}}</textarea>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="showAnnotations && is_daily && !isGuest" class="row">
            <div class="col">
                <button class="btn btn-secondary reverse float-right ml-3" @click="closeAnnotations">Close</button>
                <button class="btn btn-secondary float-right" @click="saveAnnotations">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['isGuest'],
        data() {
            return {
                nodata:true,
                date_points:[],
                current_date_point:null,
                categories:['Select Type', 'Press', 'Ads', 'Events', 'Website Update', 'Email', 'Direct', 'Organic'],
                current_category:'Select Type',
                current_annotation:'',
                raw_annotation:'',
                is_daily:null,
                annotations:{},
                editAnnotations:null,
                showAnnotations:null,
                chartData:null,
                is_watching_current_date_point:false,
                is_watching_current_category:false
            }
        },
        methods: {
            getOptionsForTrafficTrends(chartData, params, annotations, vueInstance) {
                const $this = this;
                const prefix1 = !!chartData['metric1']['prefix'] ? $.trim(chartData['metric1']['prefix']) : '';
                const prefix2 = !!chartData['metric2']['prefix'] ? $.trim(chartData['metric2']['prefix']) : '';
                const suffix1 = !!chartData['metric1']['suffix'] ? $.trim(chartData['metric1']['suffix']) : '';
                const suffix2 = !!chartData['metric2']['suffix'] ? $.trim(chartData['metric2']['suffix']) : '';
                const metric1_name = chartData['metric1']['metric_name'];
                const metric2_name = chartData['metric2']['metric_name'];
                const base_dp1 = chartData['metric1']['metric_dp'];
                const base_dp2 = chartData['metric2']['metric_dp'];
                const y_title1 = (suffix1 == 's') ? metric1_name.toUpperCase() + ' (mm:ss)' : metric1_name.toUpperCase();
                const y_title2 = (suffix2 == 's') ? metric2_name.toUpperCase() + ' (mm:ss)' : metric2_name.toUpperCase();
                let labels_y1 = [];
                let labels_y2 = [];
                let force_dp1 = false;
                let force_dp2 = false;
                let check_labels_y1 = false;
                let check_labels_y2 = false;

                this.nodata = false;
                this.hasAnnotationFeature = this.$parent.hasAnnotationFeature;
                this.date_points = chartData['full_categories'];
                if(!this.current_date_point){
                    this.current_date_point = chartData['full_categories'][0];
                }
                this.is_daily = vueInstance.$store.state.current_dwm == 'daily';
                this.annotations = annotations;
                this.editAnnotations = null;
                this.showAnnotations = null;
                this.chartData = chartData;
                let found = false;
                _.findKey(this.annotations, function(obj, key) {
                    if($this.is_daily && key == $this.current_date_point){
                        _.each(obj, (item, k) => {
                            if(!found && !_.has(obj, $this.current_category)){
                                $this.current_annotation = item.annotation;
                                $this.raw_annotation = item.raw_annotation;
                                $this.current_category = item.category;
                                found = true;
                            }
                        })
                    }
                });

                let series;
                const hasMultipleAnnotations = chartData['mult_annotations'];
                if(vueInstance.show_index_values){
                    series = [{
                        name: chartData['metric1']['metric_name'],
                        metric:metric1_name,
                        type: 'column',
                        data: chartData['data1'],
                        color:'#d3d4d6'
                    },{
                        name: chartData['metric1']['metric_name'] + ' (' + vueInstance.index_name + ')',
                        metric:metric1_name + ' (' + vueInstance.index_name + ')',
                        type: 'column',
                        data: chartData['data3'],
                        color:'#000'
                    }, {
                        name: chartData['metric2']['metric_name'],
                        metric:metric2_name,
                        type: 'line',
                        yAxis: 1,
                        data: chartData['data2'],
                        color:'#e97769'
                    },{
                        name: chartData['metric2']['metric_name'] + ' (' + vueInstance.index_name + ')',
                        metric:metric2_name + ' (' + vueInstance.index_name + ')',
                        type: 'line',
                        yAxis: 1,
                        data: chartData['data4'],
                        color:'#a95558'
                    }]
                }
                else{
                    if(this.is_daily){
                        if(hasMultipleAnnotations){
                            series = (() => {
                                // 1) Placeholder series: keep this
                                const placeholder = {
                                    name: 'Select Type',
                                    metric: metric1_name,
                                    type: 'column',
                                    data: chartData['data1'],           // baseline from backend
                                    color: '#d3d4d6',
                                    showInLegend: false,
                                    grouping: false,                    // does not occupy a group slot
                                    pointPlacement: 'on',               // centered on the category
                                    borderWidth: 0,
                                    zIndex: 0                           // stays behind actual columns
                                };

                                // 2) Original sources (use your own colors if different)
                                const sources = [
                                    { name: 'Press',           data: chartData['data1_press'],   color: '#887959' },
                                    { name: 'Ads',             data: chartData['data1_ads'],     color: '#052738' },
                                    { name: 'Events',          data: chartData['data1_events'],  color: '#80a5b9' },
                                    { name: 'Website Update',  data: chartData['data1_website'], color: '#30902b' },
                                    { name: 'Email',           data: chartData['data1_email'],   color: '#c97f54' },
                                    { name: 'Direct',          data: chartData['data1_direct'],  color: '#6c5b7b' },
                                    { name: 'Organic',         data: chartData['data1_organic'], color: '#d1495b' }
                                ];

                                const nCats =
                                    (chartData['full_categories'] && chartData['full_categories'].length) ||
                                    (chartData['categories'] && chartData['categories'].length) || 0;

                                // 3) Build per-date compacted slots (left → right)
                                const slots = []; // slots[k][i] = point in slot k at category i (or null)
                                let maxSlots = 0;

                                for (let i = 0; i < nCats; i++) {
                                    // active points (y>0) for this date, in the order of the 5 sources
                                    const active = [];
                                    for (const s of sources) {
                                        const p = s.data?.[i];
                                        const y = (typeof p === 'number') ? p : (p && p.y);
                                        if (y && y > 0) {
                                            const point = (typeof p === 'number') ? { y } : { ...p }; // preserve metadata (date, period, pointWidth, etc.)
                                            if (!point.type)  point.type  = s.name;   // for custom tooltip/legend
                                            if (!point.color) point.color = s.color;  // per-point color (if not already present)
                                            active.push(point);
                                        }
                                    }
                                    maxSlots = Math.max(maxSlots, active.length);
                                    for (let k = 0; k < active.length; k++) {
                                        if (!slots[k]) slots[k] = new Array(nCats).fill(null);
                                        slots[k][i] = active[k];
                                    }
                                }

                                // 4) Side-by-side slot series + second metric line
                                const slotSeries = [];
                                for (let k = 0; k < maxSlots; k++) {
                                    slotSeries.push({
                                        name: `Slot ${k + 1}`,
                                        metric: metric1_name,
                                        type: 'column',
                                        data: slots[k],
                                        showInLegend: false,
                                        stacking: null,
                                        grouping: true,
                                        zIndex: 1                            // above the placeholder
                                    });
                                }

                                const lineSeries = {
                                    name: chartData['metric2']['metric_name'],
                                    metric: metric2_name,
                                    type: 'line',
                                    yAxis: 1,
                                    data: chartData['data2'],
                                    color: '#e97769',
                                    zIndex: 5
                                };

                                return [placeholder, ...slotSeries, lineSeries];
                            })();

                        }
                        else{
                            series = [{
                                name: 'Select Type',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1'],
                                color:'#d3d4d6',
                                showInLegend:false
                            }, {
                                name: 'Press',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_press'],
                                color:'#887959'
                            },{
                                name: 'Ads',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_ads'],
                                color:'#052738'
                            },{
                                name: 'Events',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_events'],
                                color:'#80a5b9'
                            },{
                                name: 'Website Update',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_website'],
                                color:'#30902b'
                            },{
                                name: 'Email',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_email'],
                                color:'#c97f54'
                            },{
                                name: 'Direct',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_direct'],
                                color:'#6c5b7b'
                            },{
                                name: 'Organic',
                                metric:metric1_name,
                                type: 'column',
                                data: chartData['data1_organic'],
                                color:'#d1495b'
                            },{
                                name: chartData['metric2']['metric_name'],
                                metric:metric2_name,
                                type: 'line',
                                yAxis: 1,
                                data: chartData['data2'],
                                color:'#4c7a9f'
                            }]
                        }
                    }
                    else {
                        series = [{
                            name: chartData['metric1']['metric_name'],
                            metric:metric1_name,
                            type: 'column',
                            data: chartData['data1'],
                            color:'#d3d4d6'
                        },{
                            name: chartData['metric2']['metric_name'],
                            metric:metric2_name,
                            type: 'line',
                            yAxis: 1,
                            data: chartData['data2'],
                            color:'#e97769'
                        }]
                    }
                }

                return {
                    chart: {
                        type: 'barline',
                        events:{
                            click:true
                        }
                    },
                    xAxis: {
                        lineColor:params.axisBaseColor,
                        labels: {
                            style: {
                                color:'#afafaf',
                                fontSize:'12px',
                            }
                        },
                        categories: chartData['categories']
                    },
                    yAxis: [{
                        lineColor:params.axisBaseColor,
                        style: {
                            color:'#afafaf',
                            fontSize:'12px',
                        },
                        title: {
                            text: y_title1,
                            style: {
                                color:'#afafaf',
                                fontSize:'12px',
                            }
                        },
                        labels: {
                            style: {
                                color:'#afafaf',
                                fontSize:'12px',
                            },
                            formatter: function () {
                                let val = (suffix1 == 's') ? $this.secondsToTime(this.value) : vueInstance.niceFormat(this.value, base_dp1);
                                if(this.isFirst && labels_y1.length){
                                    check_labels_y1 = true;
                                    let found = null;
                                    _.each(labels_y1, (el) => {
                                        if(found && found == el){
                                            force_dp1 = true;
                                        }
                                        found = el;
                                    })
                                }
                                if(!check_labels_y1){
                                    labels_y1.push(val);
                                }

                                return (suffix1 == 's') ? $this.secondsToTime(this.value) : prefix1 + vueInstance.niceFormat(this.value, base_dp1, force_dp1) + suffix1;
                            }
                        }
                    },{
                        lineColor:params.axisBaseColor,
                        title: {
                            text: y_title2,
                            style: {
                                color:'#afafaf',
                                fontSize:'12px',
                            }
                        },
                        labels: {
                            style: {
                                color:'#afafaf',
                                fontSize:'12px',
                            },
                            formatter: function () {
                                let val = (suffix2 == 's') ? $this.secondsToTime(this.value) : vueInstance.niceFormat(this.value, base_dp2);
                                if(this.isFirst && labels_y2.length){
                                    check_labels_y2 = true;
                                    let found = null;
                                    _.each(labels_y2, (el) => {
                                        if(found && found == el){
                                            force_dp2 = true;
                                        }
                                        found = el;
                                    })
                                }
                                if(!check_labels_y2){
                                    labels_y2.push(val);
                                }
                                return (suffix2 == 's') ? $this.secondsToTime(this.value) : prefix2 + vueInstance.niceFormat(this.value, base_dp2, force_dp2) + suffix2;
                            }
                        },
                        opposite: true
                    }],
                    tooltip: {
                        shared: true,
                        useHTML: true,
                        backgroundColor: "rgba(255,255,255,1)",
                        followPointer: true,
                        formatter: function () {
                            // Header (daily shows formatted date from the point; otherwise use the x/category label)
                            let ret;
                            if ((this.points?.[0]?.point?.dwm) === 'daily') {
                                ret = '<b>' + this.points[0].point.date + '</b>';
                            } else {
                                ret = '<b>' + this.x + '</b>';
                            }

                            const pts = this.points || [this.point];

                            // If weekly, print the range ONCE (as your original did)
                            const weeklyPt = pts.find(p => p.point && p.point.dwm === 'weekly' && p.point.show_in_tooltip == 1);
                            if (weeklyPt) {
                                ret += '<br>' + weeklyPt.point.date.start + ' to ' + weeklyPt.point.date.end;
                            }

                            // --- Metric 1 (columns): show ONCE (do NOT ignore "Select Type") ---
                            const colPt = pts.find(p => p.point && p.point.show_in_tooltip == 1 && p.series.type === 'column');
                            if (colPt) {
                                const dp1 = vueInstance.niceDecimalPlaces(colPt.y, base_dp1);
                                if (suffix1 === 's') {
                                    const value_to_show = $this.secondsToTime(colPt.y);
                                    ret += '<br/><span style="color:' + colPt.series.color + '">\u25CF</span>'
                                        + colPt.series.options.metric + ':<span style="font-weight:bold">' + value_to_show + '</span>';
                                } else {
                                    ret += '<br/><span style="color:' + colPt.series.color + '">\u25CF</span>'
                                        + colPt.series.options.metric + ':<span style="font-weight:bold">'
                                        + prefix1 + vueInstance.addThousandCommas(colPt.y.format(dp1)) + suffix1 + '</span>';
                                }
                            }

                            // --- Metric 2 (line): show ONCE ---
                            const linePt = pts.find(p => p.point && p.point.show_in_tooltip == 2 && p.series.type === 'line');
                            if (linePt) {
                                const dp2 = vueInstance.niceDecimalPlaces(linePt.y, base_dp2);
                                if (suffix2 === 's') {
                                    const value_to_show = $this.secondsToTime(linePt.y);
                                    ret += '<br/><span style="color:' + linePt.series.color + '">\u25CF</span>'
                                        + linePt.series.name + ':<span style="font-weight:bold">' + value_to_show + '</span>';
                                } else {
                                    ret += '<br/><span style="color:' + linePt.series.color + '">\u25CF</span>'
                                        + linePt.series.name + ':<span style="font-weight:bold">'
                                        + prefix2 + vueInstance.addThousandCommas(linePt.y.format(dp2)) + suffix2 + '</span>';
                                }
                            }

                            return ret;
                        }
                    },
                    plotOptions: {
                        column: {
                            stacking: vueInstance.show_index_values ? null : 'normal',
                            pointPadding: hasMultipleAnnotations ? 0.5 : 0.12,
                            groupPadding: hasMultipleAnnotations ? 0.18 : 0.06
                        },
                        series:{
                            lineWidth:1,
                            maxPointWidth:10,
                            borderRadius:5,
                            events: {
                                legendItemClick:null
                            },
                            point:{
                                events:{
                                    click:true,
                                    mouseOver:true
                                }
                            },
                            marker: {
                                symbol: 'circle',
                                radius: 3
                            }
                        }
                    },
                    legend: {
                        itemStyle: {
                            color: '#333',
                            fontWeight: '500',
                            fontSize: '15px',
                        },
                        align: 'center',
                        symbolHeight:10
                    },
                    colors: ['#d3d4d6', '#887959', '#052738', '#80a5b9', '#e97769'],
                    series: series
                }
            },
            editAnnotationsData(){
                this.editAnnotations = true;
                this.openFroalaEditor();
                const report_element_id = this.$parent.prefixed_element_id;
                axios.get(`/api/reporting/annotation_need_refresh/${report_element_id}`).then((response) => {
                    if(response.data.success == false){
                        const message = "This report have been modified in the builder, so you need a page refresh before editingthis element."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                    }
                    else{
                        this.editUpdatesInsights = true;
                        this.openFroalaEditor();
                    }
                });
            },
            closeAnnotations(){
                const vueInstance = this;
                this.showAnnotations = false;
                setTimeout(function(){
                    vueInstance.editAnnotations = false;
                }, 1000);
            },
            saveAnnotations(){
                let annotation_data = {};
                annotation_data.annotation = $('.traffic-chart').find('.froala-annotations').froalaEditor('html.get', true);
                annotation_data.category = this.current_category;
                annotation_data.date = this.current_date_point;
                this.raw_annotation = annotation_data.annotation;

                if(!annotation_data.annotation){
                    this.current_category = 'Select Type';
                    this.raw_annotation = null;
                }

                const prefixed_id = this.$parent.prefixed_id;
                const report_id = this.$parent.report_id;
                const prefixed_element_id = this.$parent.prefixed_element_id;

                axios.post(`/api/reporting/annotations`, {
                    isArchive:              this.$parent.isArchive,
                    prefixed_id:            prefixed_id,
                    report_id:              report_id,
                    prefixed_element_id:    prefixed_element_id,
                    annotation_data:        annotation_data
                }).then((response) => {
                    if(response.data['need_refresh']){
                        const message = "This report have been modified in the builder and cannot be saved without losing this text. You will need to open a new version of this report and edit it again."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 20000);
                    }
                    else{
                        this.$notify({
                            type: 'success',
                            text: response.data['deleted'] == true ? this.messages.ANNOTATIONS_DELETED : (response.data['exists'] == true ? this.messages.ANNOTATIONS_UPDATED : this.messages.ANNOTATIONS_CREATED)
                        });
                        this.$parent.reloading = true;
                        this.$parent.fetchServerData();
                    }

                    this.current_annotation = annotation_data.annotation;
                });
            },
            openFroalaEditor(){
                const vueInstance = this;
                setTimeout(function(){
                    $('.traffic-chart').find('.froala-annotations').off('froalaEditor.initialized').froalaEditor({
                        key: 'AA12B9A4A4xC2D2F2B2A29A3C3A8B1D2sg1Ti1LXd2URVJh1DWXG==',
                        height: 200,
                        charCounterCount: false,
                        requestWithCORS: false,
                        htmlExecuteScripts: false,
                        htmlUntouched: true,
                        htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'b', 'base', 'blockquote', 'br', 'button', 'caption', 'cite', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 's', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'u', 'ul'],
                        htmlRemoveTags: ['script', 'form', 'style', 'iframe', 'input', 'select', 'option', 'video', 'audio', 'canvas', 'code', 'object', 'keygen'],
                        toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'color', 'formatOL', 'formatUL', 'insertLink', 'insertTable', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 'undo', 'redo'],
                        fontFamily: {
                            "Arial, Helvetica, sans-serif": 'Arial',
                            "Georgia, serif": 'Georgia',
                            "Impact, Charcoal, sans-serif": 'Impact',
                            "Tahoma, Geneva, sans-serif": 'Tahoma',
                            "Times New Roman, Times, serif": 'Times New Roman',
                            "Verdana, Geneva, sans-serif": 'Verdana',
                            "BentonSans Regular": 'BentonSans Regular',
                        }
                    });
                    vueInstance.showAnnotations = true;
                }, 400);
            },
            secondsToTime(secs) {
                secs = Math.round(secs);
                var divisor_for_minutes = secs % (60 * 60);
                var minutes = Math.floor(secs / 60);

                var divisor_for_seconds = divisor_for_minutes % 60;
                var seconds = Math.ceil(divisor_for_seconds);

                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return minutes + ':' + seconds;
            }
        },
        watch: {
            current_date_point(value) {
                if(this.is_watching_current_category == true){
                    this.is_watching_current_category = false;
                    return;
                }
                this.is_watching_current_date_point = true;
                const $this = this;
                let found = false;
                this.current_annotation = '';
                _.findKey(this.annotations, function(obj, key) {
                    if($this.is_daily && key == $this.current_date_point){
                        _.each(obj, (item, k) => {
                            if(!found){
                                $this.current_annotation = item.annotation;
                                $this.raw_annotation = item.raw_annotation;
                                $this.current_category = item.category;
                                found = true;
                            }
                        })
                    }
                });

                if(!found){
                    $this.current_annotation = null;
                    $this.raw_annotation = null;
                    $this.current_category = 'Select Type';
                }

                if(this.showAnnotations){
                    $('.traffic-chart').find('.froala-annotations').froalaEditor('html.set', this.raw_annotation);
                }
                setTimeout(() => {
                    $this.is_watching_current_date_point = false;
                }, 1000)
            },
            current_category(value){
                if(this.is_watching_current_date_point == true){
                    this.is_watching_current_date_point = false;
                    return;
                }
                this.is_watching_current_category = true;
                const $this = this;
                let found = false;
                this.current_annotation = '';
                _.findKey(this.annotations, function(obj, key) {
                    if($this.is_daily && key == $this.current_date_point){
                        _.each(obj, (item, k) => {
                            if(!found && k == $this.current_category){
                                $this.current_annotation = item.annotation;
                                $this.raw_annotation = item.raw_annotation;
                                found = true;
                            }
                        })
                    }
                });

                if(!found){
                    $this.current_annotation = null;
                    $this.raw_annotation = null;
                }

                if(this.showAnnotations){
                    $('.traffic-chart').find('.froala-annotations').froalaEditor('html.set', this.raw_annotation);
                }
                setTimeout(() => {
                    $this.is_watching_current_category = false;
                }, 1000)
            }
        }
    }
</script>
<style lang="scss">
    div.traffic-chart{
        position:relative;
        div.edit-annotations{
            position:absolute;
            right:0;
            top:-3.2rem;
            &.editing{
                top:-8rem;
            }
            svg{
                width:2.4rem;
                cursor:pointer;
            }
            span.edit-annotations{
                display:inline-block;
                float:right;
                margin-right:1.5rem;
            }
        }
        div.v-select{
            width:17rem;
        }
    }
</style>
